import { HEADER_TOTAL_HEIGHT } from '@inbody/ui';

/**
 * GenericLayout 안에서 페이지가 채울 수 있는 높이 —
 * 머리띠·위 24px(Container 의 mt 8px + p 16px)·아래 16px 를 뺀 높이.
 * 배율 화면에서 반올림으로 페이지 스크롤바가 생기지 않게 1px 여유를 둔다.
 */
export const CONTENT_HEIGHT = `calc(100vh - ${HEADER_TOTAL_HEIGHT + 24 + 16 + 1}px)`;
